module.exports = __webpack_public_path__ + "static/media/ic_success_check.85ed4bee.svg";